export type UseOpenGraphProtocolProps = {
  enabled: boolean;
  pageDescription?: string;
  pageLocale?: string;
  pageTitle?: string;
  pageType?: string;
  pageUrl?: string;
  siteName?: string;
}

export function useOpenGraphProtocol({
  enabled,
  pageDescription,
  pageLocale,
  pageTitle,
  pageType,
  pageUrl,
  siteName
}: UseOpenGraphProtocolProps) {
  if (!enabled) {
    return <></>
  }

  return (
    <>
      {pageDescription && <meta key='og_description' property='og:description' content={pageDescription} />}
      {pageLocale && <meta key='og_locale' property='og:locale' content={pageLocale} />}
      {siteName && <meta key='og_site_name' property='og:site_name' content={siteName} />}
      {pageTitle && <meta key='og_title' property='og:title' content={pageTitle} />}
      {pageType && <meta key='og_type' property='og:type' content={pageType} />}
      {pageUrl && <meta key='og_url' property='og:url' content={pageUrl} />}
    </>
  )
}
